import React, { useEffect, useState } from 'react'
import { getTime, setMinutes, setSeconds, setMilliseconds } from 'date-fns'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import { useRequestFromSearch, useGetDataByPayload } from '../../../utils/default/ComplexFlowHook'
import useGDK from '../../../providers/admin/gdk/useGDK'
import useT from '../../../i18ns/admin/useT'
import { usePageFlow } from '../../../utils/default/PageFlowHook'
import LoadingAndErrorFrame from '../../../components/default/frames/LoadingAndErrorFrame'
import AdminReportRevenueTrendForm, { searchToRequest } from '../../../components/admin/adminReport/AdminReportRevenueTrendForm'
import { RevenueTrend } from '@golden/gdk-admin/dist/interface/RevenueTrend'
import AdminReportRevenueTrendTable from '../../../components/admin/adminReport/AdminReportRevenueTrendTable'

const getCurrentHalfHour = (): number => {
  const now = new Date()
  return getTime(setMilliseconds(setSeconds(setMinutes(now, now.getMinutes() < 30 ? 0 : 30), 0), 0))
}

const AdminReportRevenueTrend: React.FC = () => {
  const gdk = useGDK()
  const { t } = useT()
  const request = useRequestFromSearch({ searchToRequest })
  const [result, setResult] = useState<RevenueTrend>({
    revenue: []
  })
  const pageFlow = usePageFlow()
  const isStartInFuture = request !== undefined && request.start_at > Date.now()
  useEffect(() => {
    if (isStartInFuture) pageFlow.setError(t('common.noDataFound'))
  }, [request, isStartInFuture])
  useEffect(() => {
    console.log({ result })
  }, [result])
  useGetDataByPayload({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    payload: request!,
    gdkFunc: (payload) => gdk.history.getRevenueTrend({ ...payload, end_at: Math.min(payload.end_at, getCurrentHalfHour()) }),
    gdkFuncDependencies: [gdk],
    onBeforeFetch: pageFlow.setLoadingStart,
    onSuccess: (res: RevenueTrend) => {
      setResult(res)
      pageFlow.setContentShow()
    },
    onError: pageFlow.setGDKError,
    canLoadData: request !== undefined && !isStartInFuture
  })
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <AdminReportRevenueTrendForm request={request} />
      </Box>
      <LoadingAndErrorFrame error={null} loading={false} showContent={!pageFlow.status.showContent}>
        <Box paddingX={5} paddingY={3}>
          <Paper>
            <Box padding={5}>
              <LoadingAndErrorFrame { ...pageFlow.status }></LoadingAndErrorFrame>
            </Box>
          </Paper>
        </Box>
      </LoadingAndErrorFrame>
      {request && (
        <LoadingAndErrorFrame { ...pageFlow.status } error={null} loading={false}>
          {request && result?.revenue && (
            <Box marginTop={3}>
              <AdminReportRevenueTrendTable request={request} result={result} />
            </Box>
          )}
        </LoadingAndErrorFrame>
      )}
    </Box>
  )
}

export default React.memo(AdminReportRevenueTrend)
